import { useTranslation } from 'react-i18next';

import { faqPagesQuery } from '@/entities/faq/queries';
import { usePageTitle } from '@/features/pageTitle';
import { FaqPageDto } from '@/shared/api/faq/types';
import { useAppQuery } from '@/shared/lib/useAppQuery';
import { Box, Card } from '@/shared/ui';
import { Loader } from '@/shared/ui/Loader';
import { PageContainer } from '@/shared/ui/PageContainer';
import { SvgIcon } from '@/shared/ui/SvgIcon';
import { CustomTypography } from '@/shared/ui/Typography';

export const FAQPage = () => {
  const { t } = useTranslation();

  usePageTitle(t('common:menu.faq'));

  const { data: pages, isPending } = useAppQuery(faqPagesQuery());

  const getUrl = (path: string) => {
    return `${import.meta.env.VITE_GITBOOK_PUBLIC_URL}/${path}`;
  };

  return (
    <PageContainer>
      {isPending ? (
        <Loader containerSize="medium" />
      ) : (
        <Box sx={{ p: 4, width: '100%' }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              minWidth: 600,
            }}
          >
            {pages?.map((page: FaqPageDto) => (
              <Card
                key={page.id}
                component="a"
                href={getUrl(page.path)}
                target="_blank"
                sx={{
                  p: 3,
                  bgcolor: 'grey.100',
                  borderRadius: 1,
                  height: 72,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  textDecoration: 'none',
                  '&:hover': {
                    bgcolor: 'grey.200',
                  },
                }}
              >
                <CustomTypography>{page.title}</CustomTypography>
                <SvgIcon name="expand" />
              </Card>
            ))}
          </Box>
        </Box>
      )}
    </PageContainer>
  );
};
